export interface ISupplierEditorData {
  id?: string | null;
  allowEdit?: boolean;
  label?: string | null;
  isActive?: boolean;
  disabled?: boolean;
  parentProvider?: string;
  providerIdentityCode?: string;
  isMixAndMatchProvider?: boolean;
}

export interface IEditorData {
  supplierEditorData: ISupplierEditorData;
  validation?: any;
}

export class SupplierEditorData implements ISupplierEditorData {
  id?: string | null;
  allowEdit?: boolean;
  label?: string | null;
  isActive?: boolean;
  disabled?: boolean;
  aggregatorProvider?: string | undefined;
  providerIdentityCode?: string | undefined;
  isMixAndMatchProvider?: boolean;

  constructor() {
    this.disabled = true;
  }
}

export class EditorData implements IEditorData {
  supplierEditorData: ISupplierEditorData;
  validation?: any;

  constructor() {
    this.supplierEditorData = new SupplierEditorData();
  }
}
